import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { mapGetters } from 'vuex';
import getJsonLD, { TYPES } from '~/helpers/json-ld';
var getHomepageJsonLD = getJsonLD(TYPES.HOMEPAGE);
export default {
  name: 'HomepageJsonLD',
  props: {
    prismic: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    url: 'request/baseURL'
  }), {
    scriptJsonLD: function scriptJsonLD() {
      var prismic = _objectSpread({}, this.prismic, {
        url: this.url
      });

      return {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(getHomepageJsonLD(prismic, this.locale)),
        body: true
      };
    }
  }),
  head: function head() {
    return {
      script: [this.scriptJsonLD]
    };
  },
  render: function render(h) {
    return h(null);
  }
};